module.exports = __webpack_public_path__ + "static/img/hot.d6098920.png";